<template>
	<div id="Fxpertthinkatnk" class="pub_pub">
		<div class="pub_title">
			<div class="img_logo">
				<img src="../imges/lebiao/zjzk.png" alt="">
			</div>
			<div class="title_t">
				<div class="imhg_ti">
					<img src="../imges/lebiao/qkyda.png" alt="">
				</div>
				<div class="sm_t">
					<div style="float:left"><span>期刊</span><span style="color:#D7230C;">阅读</span></div>
					<div class="sm_pub">期刊阅读</div>
				</div>
			</div>
			<router-link tag="div" class="ckgd" to="/bkqk">
				查看更多&nbsp;>
			</router-link>
		</div>
		<el-carousel style="box-shadow: 0 4px 24px rgba(0,0,0,.16);margin-top: 10px;" :interval="5000" arrow="none">
			<el-carousel-item v-for="(item,index) in 2" :key="index">
				<div class="z_warp">
					<router-link tag="div" :to="{ path:'/bgqkdetail',query:{id:o.id,title:o.title} }"  style="height: 270px;margin-top: 15px;" class="lb_cont" v-for="(o,index) in xptjlist[index]" :key="index">
						<div class="list_lb_img" style="height: 240px;">
							<img v-lazy=" 'https://admin.shipoe360.com/public/' + o.picture " alt="">
						</div>
						<div class="xp_title" style="text-align: center;height: 30px;line-height: 30px;margin-top: 0px;font-size: 14px;">
							 {{o.title}}
						</div>
						<!-- <div tag="div" class="ckxq_xp"
							>
							查看详情
						</div> -->
					</router-link>
				</div>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				xptjlist: ''
			}
		},
		methods: {

		},
		async mounted() {
			let res = await http.post('api/picture/foreign_journals', {
			})
			console.log(res.data.data.list)
			let xpList = res.data.data.list
			let newArr = [
				[],
				[],
			]
			xpList.forEach((item, index) => {
				if (index < 5) {
					newArr[0].push(item)
				} else if (index >= 5 && index < 10) {
					newArr[1].push(item)
				} 
			})
			this.xptjlist = newArr
		}
	}
</script>

<style>
	#Fxpertthinkatnk {
		box-shadow: 10px 20px 10px -15px rgb(231, 231, 231);
	}

	/* 头部 */
	#Fxpertthinkatnk .pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
	}

	#Fxpertthinkatnk .pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	#Fxpertthinkatnk .img_logo>img {
		width: 100%;
		height: 100%;
	}

	#Fxpertthinkatnk .img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	#Fxpertthinkatnk .title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	#Fxpertthinkatnk .imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	#Fxpertthinkatnk .imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	#Fxpertthinkatnk .sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	#Fxpertthinkatnk .sm_pub>ul::after {
		content: '';
		display: block;
		clear: both;
	}

	#Fxpertthinkatnk .sm_pub {
		float: left;
		margin-left: 40px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	#Fxpertthinkatnk .ct_title {
		float: left;

	}

	#Fxpertthinkatnk .ct_img {
		float: left;
		margin-left: 10px;
	}

	#Fxpertthinkatnk .ct_img>img {
		width: 12px;
		height: 10px;
	}

	#Fxpertthinkatnk .ckgd {
		float: right;
		margin-right: 20px;
		color: #999999;
		font-size: 15px;
		height: 36px;
		line-height: 46px;
		cursor: pointer;
	}

	/* 结尾 */

	#Fxpertthinkatnk .z_warp::after {
		content: '';
		display: block;
		clear: both;
	}

	#Fxpertthinkatnk .lb_cont {
		float: left;
		width: calc((100% - 250px)/5);
		margin-left: 24px;
		height: 230px;
		/* border: 1px solid #ececec; */
		box-shadow: rgb(0 0 0 / 16%) 0px 4px 24px;
	}

	#Fxpertthinkatnk .list_lb_img {
		height: 250px;
	}

	#Fxpertthinkatnk .list_lb_img>img {
		width: 100%;
		height: 100%;
	}

	#Fxpertthinkatnk .xp_title {
		margin-left: 8px;
		font-size: 16px;
		font-weight: 600;
		margin-top: 12px;
		margin-bottom: 8px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
	}

	#Fxpertthinkatnk  .ckxq_xp {
		width: 80px;
		border: 1px solid #ff4400;
		color: #ff4400;
		text-align: center;
		padding: 2px 0px;
		margin: 10px auto;
		cursor: pointer;
	}

	#Fxpertthinkatnk /deep/.el-carousel__container {
		height: 350px;
		margin-top: 20px;
	}
</style>
